/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Abilities_HintInputs */



/**
* | output |
* | --- |
* | "Leave this alone and it can do everything the chat can. Pick groups to keep it to just those." |
*
* @param {Agent_Wizard_Abilities_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_abilities_hint = /** @type {((inputs?: Agent_Wizard_Abilities_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Abilities_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lassen Sie das unverändert, kann er alles, was der Chat kann. Wählen Sie Gruppen aus, beschränkt er sich auf genau diese.")
	return /** @type {LocalizedString} */ ("Leave this alone and it can do everything the chat can. Pick groups to keep it to just those.")
});